module.exports = __webpack_public_path__ + "img/placeholder5.7b792034.png";